// 问卷调查用到的选项

// 公司注资以及未来运营的资金来源
export const moneySourceList = [
  { zh: "薪资", en: "Savings from employment", value: "Savings from employment" },
  { zh: "经营产生的利润", en: "Profits generated from business", value: "Profits generated from business" },
  { zh: "投资盈利", en: "Investment gain", value: "Investment gain" },
  { zh: "借款(如银行、金融机构)", en: "Loans (e.g. Banks or Financial Institutions)", value: "Loans (e.g. Banks or Financial Institutions)" },
  { zh: "从家庭和朋友的借款", en: "Loans from family and friends", value: "Loans from family and friends" },
  { zh: "个人储蓄", en: "Personal savings", value: "Personal savings" },
  { zh: "遗产", en: "Inheritance", value: "Inheritance" },
  { zh: "投资人", en: "Investors", value: "Investors" },
  { zh: "其他方式，请列明", en: "Others, please specify", value: "Others, please specify" },
];
// 你是如何知道我们提供的公司服务
export const understandWayList = [
  { zh: "搜索网站", en: "Search Engine", value: "Search Engine" },
  { zh: "社交媒体", en: "Social Media", value: "Social Media" },
  { zh: "朋友或EStar员工推荐", en: "Referral from friend(s) or EStar staff(s)", value: "Referral from friend(s) or EStar staff(s)" },
  { zh: "其他公司或中介推荐，请列明", en: "Referral from other company or agent, please specify", value: "Referral from other company or agent, please specify" },
  { zh: "其他方式，请列明", en: "Others, please specify", value: "Others, please specify" },
];
